import { defineMessages } from '@cookbook/solid-intl'

/*
    TENANT-5421. Split from `lodgr-insights-page.messages.en.js` so the
    router's document-title/meta-description wiring doesn't eagerly pull the
    whole page catalog into the boot-critical chunk (same split as
    `installed-page-routing.messages.en.js`, TENANT-5036).
*/
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Lodgr Insights arms guests with real pricing data — while you keep 100% of every booking.',
        id: 'LodgrInsightsPage.descriptionMessage',
    }),
    // TENANT-5470: fresh id (not `titleMessage`) — the pushed generated
    // catalogs still carry the "— STR Summit 2026" suffix under the old id.
    titleMessage: defineMessages({
        defaultMessage: 'Lodgr Insights',
        id: 'LodgrInsightsPage.documentTitle',
    }),
}
